/** The hunting log (ADR 0093): its window, its region tabs and its pages. */
export const BESTIARY: Readonly<Record<string, string>> = {
  // settings/keybindings.ts, ui/bestiary-panel.ts
  'Carnet de chasse': 'Hunting Log',
  '{seen} / {total} créatures rencontrées': '{seen} / {total} creatures met',
  // The region tabs show the first word of the region's name.
  Forêt: 'Forest',
  Désert: 'Desert',
  Pics: 'Peaks',

  // ui/bestiary-page.ts
  Élite: 'Elite',
  Boss: 'Boss',
  'Aucun palier': 'No tier yet',
  'Palier {tier} · +{bonus} de dégâts': 'Tier {tier} · +{bonus} damage',
  '{kills} vaincus · palier maximal': '{kills} slain · top tier',
  '{kills} / {next} vaincus': '{kills} / {next} slain',
  'Aucun butin vu': 'No loot seen yet',
};
